import { SelectButtonDesignTokens } from '@primeuix/themes/aura/selectbutton';

export const selectButtonTokens: SelectButtonDesignTokens = {
  root: {
    borderRadius: '{form.field.border.radius}',
    invalidBorderColor: '{form.field.invalid.border.color}',
  },
};
